import { useState } from "react";
import { Form, Input, Button, Card, Row, Col, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import signup from "@/projects/Civi_Circle_Admin/assets/signup.png";
import { getTenantId } from "@/lib/storeManager";
import MMNavigationRoutes from "../../utils/navigationRoutes";
import navigationRoutes from "@/utils/navigationRoutes";
import { ZulipService } from "@/services/APIs";

const { Title, Text, Paragraph } = Typography;

const SignUpPage: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const tenantId = getTenantId() ?? "";
  console.log(tenantId);

  const fetchTokenOnce = async () => {
    const existingToken = localStorage.getItem("zulipToken");
    const existingUser = localStorage.getItem("zulipUserId");

    if (existingToken && existingUser) {
      return;
    } // Already fetched

    try {
      const res = await ZulipService.getZulipToken();
      localStorage.setItem("zulipToken", res.basic_token);
      localStorage.setItem("zulipUserId", res.zulip_user_id);
    } catch (err) {
      console.error("Zulip Token fetch failed:", err);
    }
  };

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      console.log("Form values:", values);
      console.log("Tenant ID:", tenantId);

      // Get API base URL from environment variable
      const apiBaseUrl =
        import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8000";
      const apiUrl = `${apiBaseUrl}/city_collab/organization-sign-up/`;

      console.log("API URL:", apiUrl);

      // Call the API with tenant ID in header
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Tenant-ID": tenantId || "scane hall project",
        },
        body: JSON.stringify(values),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Sign up successfully:", result);

        // Extract organization ID from the response
        const organizationId = result.organization?.id;
        console.log("Organization ID:", organizationId);
        localStorage.setItem("accessToken", result.access);
        localStorage.setItem("refreshToken", result.refresh);

        message.success("Account created successfully...!!");
        await fetchTokenOnce(); // fetch Zulip token after login
        // Redirect to dashboard after successful signup
        navigate(
          "/mm" +
            MMNavigationRoutes.EDIT_CHAPTER_PROFILE(organizationId) +
            `?email=${encodeURIComponent(values.work_email)}`
        );
      } else {
        const errorData = await response.json();
        console.error("API Error:", errorData);

        // Handle specific error cases
        if (errorData.details?.name) {
          message.error(
            "Organization already exists. Please try with a different organization name."
          );
        } else if (errorData.details?.full_name) {
          message.error(
            "User already exists. Please try with a different email address."
          );
        } else if (
          errorData.details &&
          typeof errorData.details === "string" &&
          errorData.details.includes("user_already_exists")
        ) {
          message.error(
            "User already exists. Please try with a different email address."
          );
        } else if (
          errorData.details &&
          typeof errorData.details === "string" &&
          errorData.details.includes("organization_exists")
        ) {
          message.error(
            "Organization already exists. Please try with a different organization name."
          );
        } else if (errorData.error) {
          message.error(errorData.error);
        } else {
          message.error("Registration failed. Please try again.");
        }
      }
    } catch (error) {
      console.error("Sign up failed:", error);
      message.error("Failed to create account. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
    message.error("Please fill in all required fields correctly.");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        // background: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Row
        gutter={[0, 0]}
        style={{
          width: "100%",
          maxWidth: "1200px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
          borderRadius: "16px",
          overflow: "hidden",
        }}
      >
        {/* Left Side - Sign Up Form */}
        <Col xs={24} lg={12}>
          <Card
            style={{
              height: "100%",
              borderRadius: "16px",
              border: "none",
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
            }}
            bodyStyle={{ padding: "48px" }}
          >
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <Title
                level={2}
                style={{
                  color: "#635DE8",
                  marginBottom: "8px",
                  fontSize: "30px",
                }}
              >
                Start Free Trial
              </Title>
            </div>

            <Form
              form={form}
              name="signup"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              size="large"
            >
              <Form.Item
                name="work_email"
                label={
                  <span
                    style={{
                      color: "#66697C",
                      fontWeight: "500",
                    }}
                  >
                    Work Email
                  </span>
                }
                rules={[
                  { required: true, message: "Please input your work email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input
                  className="border-[#E8E8FF] p-3 font-sans text-sm font-medium placeholder:!text-[#A7A7B7]"
                  placeholder="Work Email"
                />
              </Form.Item>

              <Form.Item
                name="full_name"
                label={
                  <span
                    style={{
                      color: "#66697C",
                      fontWeight: "500",
                    }}
                  >
                    Full Name
                  </span>
                }
                rules={[
                  { required: true, message: "Please input your full name!" },
                ]}
              >
                <Input
                  className="border-[#E8E8FF] p-3 font-sans text-sm font-medium placeholder:!text-[#A7A7B7]"
                  placeholder="Full Name"
                />
              </Form.Item>

              <Form.Item
                name="organization"
                label={
                  <span
                    style={{
                      color: "#66697C",
                      fontWeight: "500",
                    }}
                  >
                    Organization / Agency
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please input your organization!",
                  },
                ]}
              >
                <Input
                  className="border-[#E8E8FF] p-3 font-sans text-sm font-medium placeholder:!text-[#A7A7B7]"
                  placeholder="Organization / Agency"
                />
              </Form.Item>

              <Form.Item
                name="password"
                label={
                  <span
                    style={{
                      color: "#66697C",
                      fontWeight: "500",
                    }}
                  >
                    Password
                  </span>
                }
                rules={[
                  { required: true, message: "Please input your password!" },
                  {
                    min: 6,
                    message: "Password must be at least 6 characters!",
                  },
                ]}
              >
                <Input.Password
                  className="border-[#E8E8FF] p-3 font-sans text-sm font-medium placeholder:!text-[#A7A7B7]"
                  placeholder="Password"
                />
              </Form.Item>

              {/* <Form.Item
                name="role"
                label="Your Role (Optional)"
              >
                <Input placeholder="Your Role (optional)" />
              </Form.Item> */}

              {/* <Form.Item
                name="agreement"
                valuePropName="checked"
                rules={[
                  { 
                    validator: (_, value) => 
                      value ? Promise.resolve() : Promise.reject(new Error('Please accept the Terms and Privacy Policy'))
                  }
                ]}
              >
                <Checkbox>
                  I agree to the Terms and Privacy Policy
                </Checkbox>
              </Form.Item> */}

              <Form.Item style={{ marginBottom: "24px" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={loading}
                  disabled={loading}
                  style={{
                    height: "48px",
                    background: "#635DE8",
                    borderColor: "#635DE8",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "600",
                    marginTop: "20px",
                  }}
                >
                  {loading ? "Creating Account..." : "Start Free Trial"}
                </Button>
              </Form.Item>
            </Form>

            <div style={{ textAlign: "center" }}>
              <Text
                style={{
                  color: "#66697C",
                  fontSize: "14px",
                  fontWeight: "500 ",
                }}
              >
                Already have an account?{" "}
                <Text
                  style={{
                    color: "#635DE8",
                    cursor: "pointer",
                    fontWeight: "600",
                    textDecoration: "underline",
                  }}
                  onClick={() => navigate("/" + navigationRoutes.ADMIN_LOGIN)}
                >
                  Login
                </Text>
              </Text>
            </div>
          </Card>
        </Col>

        {/* Right Side - Promotional Content */}
        <Col xs={24} lg={12}>
          <div
            style={{
              height: "100%",
              minHeight: "600px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
              padding: "60px 48px",
              position: "relative",
              overflow: "hidden",
              backgroundImage: `url(${signup})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* Dark Overlay for better text readability */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.4)",
                zIndex: 1,
              }}
            />

            {/* Geometric Shapes Background */}
            <div
              style={{
                position: "absolute",
                top: "10%",
                right: "10%",
                width: "120px",
                height: "120px",
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "20px",
                transform: "rotate(45deg)",
                zIndex: 2,
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "20%",
                left: "5%",
                width: "100px",
                height: "100px",
                background: "rgba(255, 255, 255, 0.08)",
                borderRadius: "50%",
                zIndex: 2,
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "30%",
                left: "15%",
                width: "80px",
                height: "80px",
                background: "rgba(255, 255, 255, 0.06)",
                borderRadius: "12px",
                transform: "rotate(-30deg)",
                zIndex: 2,
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "60%",
                right: "20%",
                width: "60px",
                height: "60px",
                background: "rgba(255, 255, 255, 0.05)",
                borderRadius: "8px",
                transform: "rotate(60deg)",
                zIndex: 2,
              }}
            />

            {/* Content */}
            <div
              style={{
                position: "relative",
                zIndex: 3,

                color: "white",
                width: "100%",
                maxWidth: "700px",
              }}
            >
              {/* Main Title */}
              <Title
                level={1}
                style={{
                  color: "white",
                  marginBottom: "24px",
                  fontSize: "40",
                  fontWeight: "700",

                  lineHeight: "1.2",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                }}
              >
                Try City Collab One free for 30 days
              </Title>

              {/* Description */}
              <Paragraph
                style={{
                  color: "rgba(255, 255, 255, 0.95)",
                  fontSize: "16px",
                  marginBottom: "30px",
                  lineHeight: "1.6",

                  margin: "0 auto 40px auto",
                  textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
                }}
              >
                Create a unified workspace for your city departments and public
                agencies to collaborate seamlessly.
              </Paragraph>

              {/* Feature List */}
              <div
                style={{
                  textAlign: "left",
                  maxWidth: "450px",
                  margin: "0 auto",
                }}
              >
                <ul
                  style={{
                    color: "white",

                    paddingLeft: "0",
                    listStyle: "none",
                  }}
                >
                  <li
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "flex-start",
                      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <span
                      style={{
                        color: "#60a5fa",
                        marginRight: "12px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)",
                      }}
                    >
                      âœ“
                    </span>
                    One platform for all civic collaboration â€” Departments,
                    NGOs, vendors, and citizens in one place.
                  </li>
                  <li
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "flex-start",
                      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <span
                      style={{
                        color: "#60a5fa",
                        marginRight: "12px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)",
                      }}
                    >
                      âœ“
                    </span>
                    Smart public engagement â€” Create, manage, and track city
                    projects and feedback.
                  </li>
                  <li
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "flex-start",
                      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <span
                      style={{
                        color: "#60a5fa",
                        marginRight: "12px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)",
                      }}
                    >
                      âœ“
                    </span>
                    Secure data-sharing â€” Multi-level permissions for internal
                    and inter-department workflows.
                  </li>
                  <li
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "flex-start",
                      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <span
                      style={{
                        color: "#60a5fa",
                        marginRight: "12px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)",
                      }}
                    >
                      âœ“
                    </span>
                    Real-time communication â€” Chat, updates, and task boards
                  </li>
                  <li
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
                      fontSize: "20px",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    Start transforming how your city connects and collaborates.
                  </li>
                  <li
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
                      fontSize: "25px",
                      fontWeight: "700",
                      textAlign: "center",
                    }}
                  >
                    Join City Collab Today
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignUpPage;
